import React, { useEffect, useRef, useState } from 'react';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { Button, Checkbox, Col, DatePicker, Form, Input, InputNumber, Row, Select, Spin } from 'antd';
import TextArea from 'antd/es/input/TextArea';
import Title from 'antd/es/typography/Title';
import { APP_LOCAL_DATE_FORMAT, APP_LOCAL_DATE_FORMAT_PAYLOAD } from 'app/config/constants';
import { checkInKrQualMonth, checkInKrQualQuarter, checkInQualititativeMidYear, checkInQualititativeMidYearAdjustment, getKrQualCheckInMidYear, reset } from 'app/entities/checkIn/checkIn.reducer';
import { getBoxWorkStatus } from 'app/entities/common/common.reducer';
import { checkInKrQualAdjust, getAdjustmentMidYearQualitative, resetAdjustmentMidYearQualitative } from 'app/entities/kr/kr-qualitative.reducer';
import ObjectiveUpdate from 'app/entities/objective/form/objective-update';
import AdjustObjectiveUpdate from 'app/entities/objective/form/objective-update-adjustment';
import { getEntity as getDetailObject } from 'app/entities/objective/objective.reducer';
import { EvaluationTypes } from 'app/shared/model/enum/evaluation-type.enum';
import { StatusType } from 'app/shared/model/enum/status.enum';
import { formatNumber, parseNumber } from 'app/shared/util/help';
import { displayPercent, percent } from 'app/shared/util/percent';
import { filterOption } from 'app/shared/util/select-filter';
import dayjs from 'dayjs';
import * as _ from 'lodash';
import { log } from 'react-jhipster';

type IReportQualitativeResult = {
    handleClose: () => void;
    krCheckIn?: any;
    handleNextData: () => void;
    hideNextKr: boolean;
    onClose?: () => void;
    idKrBaseSelected?: string;
    idObjective?: string;
    krTypeRequest?: number;
    planPeriodIdSelected?: string;
    planPeriodType?: any;
    handleChangeKRType?: (value: any) => void;
    isEdit?: boolean;
    isReadOnly?: boolean;
    selectedPeriod?: any;
    krType?: any;
};

export const CopyKRQualitativeVer = ({ handleClose, krCheckIn, handleNextData, hideNextKr, onClose, idKrBaseSelected, idObjective, krTypeRequest, planPeriodIdSelected, planPeriodType, handleChangeKRType, isEdit, isReadOnly, selectedPeriod, krType }: IReportQualitativeResult) => {
    const dispatch = useAppDispatch();
    const [form] = Form.useForm();
    const filters = useAppSelector(state => state.filters.orgCheckIn);
    const objectiveEntity = useAppSelector(state => state.objective.entity);
    const entity = useAppSelector(state => state.checkIn.entity);
    const [isOpenModalFormObjective, setIsOpenModalFormObjective] = useState(false);
    const [isOpenAdjustmentModel, setOpenAdjustmentModel] = useState(false);
    const [isUpdating, setUpdating] = useState(false);
    const modalContentRef = useRef(null);
    const adjustmentMidYearQualitative = useAppSelector(state => state.krQualitative.
        adjustmentMidYearQualitative);
    const loadingAdjustmentMidYearQualitative = useAppSelector(state => state.krQualitative.loadingAdjustmentMidYearQualitative);

    // watch values form
    const progressionPointValue = Form.useWatch('progressionPoint', form);
    const qualityPointValue = Form.useWatch('qualityPoint', form);
    const purposeYearValue = Form.useWatch('purpose-0', form);
    const purposeQuarterValue = Form.useWatch('purpose-1', form);
    const purposeMonthOneValue = Form.useWatch('purpose-2', form);
    const purposeMonthTwoValue = Form.useWatch('purpose-3', form);
    const purposeMonthThreeValue = Form.useWatch('purpose-4', form);

    useEffect(() => {
        if (krCheckIn && filters) {
            form.resetFields();
            innitData();
        }
    }, [krCheckIn]);

    useEffect(() => {
        if (adjustmentMidYearQualitative) {
            form.setFieldValue('planPeriodName', adjustmentMidYearQualitative?.planPeriodName)
            form.setFieldValue('reportScheduleName', adjustmentMidYearQualitative?.reportScheduleName)
            if (adjustmentMidYearQualitative) {
                form.setFieldValue('adjustmentReason', adjustmentMidYearQualitative?.adjustmentReason)
                form.setFieldValue('adjustmentIssue', adjustmentMidYearQualitative?.adjustmentIssue)
                form.setFieldValue('adjustmentNote', adjustmentMidYearQualitative?.adjustmentNote)
                form.setFieldValue('adjustmentSolution', adjustmentMidYearQualitative?.adjustmentSolution)
            }
        }
    }, [adjustmentMidYearQualitative]);

    useEffect(() => {
        if (qualityPointValue !== null && progressionPointValue !== null) {
            const { evaluationMethods } = entity?.keyResultQuarter || {};
            const includesProgress = evaluationMethods?.includes(EvaluationTypes.Progress);
            const includesQuality = evaluationMethods?.includes(EvaluationTypes.Quality);

            if (includesProgress && !includesQuality) {
                form.setFieldValue('finalPoint', progressionPointValue);
            } else if (includesQuality && !includesProgress) {
                form.setFieldValue('finalPoint', qualityPointValue);
            } else {
                form.setFieldValue('finalPoint', (qualityPointValue + progressionPointValue) / 2);
            }
        }
    }, [qualityPointValue, progressionPointValue]);

    useEffect(() => {
        form.validateFields(['purpose-2', 'purpose-3', 'purpose-4']);
    }, [purposeQuarterValue, purposeMonthOneValue, purposeMonthTwoValue, purposeMonthThreeValue]);


    const innitData = () => {
        dispatch(getBoxWorkStatus({ statusType: 1 }));
        dispatch(getKrQualCheckInMidYear({ krId: krCheckIn?.id }));
    };

    const handleOpenModalAdjustmentObjective = () => {
        setOpenAdjustmentModel(true);
    };

    const handleCloseModalAdjustmentObjective = reload => {
        setOpenAdjustmentModel(false);
        if (reload) {
            dispatch(getDetailObject(adjustmentMidYearQualitative?.objective?.id));
        }
    };

    const MapperPayload = (values: any) => {
        const {
            workStatusMonth,
            completedOnMonth,
            expectedCompleteOnMonth,
            completeNoteMonth,
            unFinishNoteMonth,
            workStatusQuarter,
            completedOnQuarter,
            expectedCompleteOnQuarter,
            completeNoteQuarter,
            unFinishNoteQuarter,
            adjustmentSolution,
            adjustmentReason,
            adjustmentIssue,
            adjustmentNote,
            progressionPoint,
            sendingNotification,
            qualityPoint,
            finalPoint,
            ratingNote,
            reportScheduleId,
            reportScheduleName,
            planPeriodName,
            ...remainingValues
        } = values;
        // Khởi tạo mảng khóa
        const keys = Object.keys(remainingValues);
        // Chia mảng thành các nhóm nhỏ, mỗi nhóm có 3 phần tử
        const groupedKeys = _.chunk(keys, 3);
        // Tạo mảng mới từ các nhóm khóa
        const subs = _.map(groupedKeys, group => {
            const mapper = _.map(group, key => {
                if (key.includes('startDate') || key.includes('dueDate')) {
                    return dayjs(remainingValues[key]).format(APP_LOCAL_DATE_FORMAT_PAYLOAD); // Định dạng ngày theo ý muốn
                }
                return remainingValues[key];
            });
            return _.zipObject(['purpose', 'startDate', 'dueDate', 'planPeriodId'], mapper);
        });
        const combinedSubs = subs.map((item, index) => {
            if (item.purpose !== null && item.purpose !== undefined) {
                return {
                    ...item,
                    planPeriodId: adjustmentMidYearQualitative?.krApproved[index]?.planPeriodId
                };
            }
        });

        const valueAdjustment = {
            adjustmentSolution,
            adjustmentReason,
            adjustmentIssue,
            krId: krCheckIn?.id,
            adjustmentNote,
            sendingNotification,
            subs: _.filter(combinedSubs, (o) => { return o !== null && o !== undefined }),
        };
        return { valueAdjustment };
    };

    useEffect(() => {
        if (isUpdating) {
            handleClose();
        }
    }, [isUpdating]);

    const handleSubmit = values => {
        const { valueAdjustment } = MapperPayload(values);
        setUpdating(true);
        dispatch(checkInQualititativeMidYearAdjustment({ krId: idKrBaseSelected, adjustment: valueAdjustment }))
            .then(response => {
                const isFailed = _.some(response, (o: any) => {
                    return !o.payload;
                });
                if (isFailed) return;
                form.resetFields();
                handleClose();
            })
            .catch(() => {
                return;
            })
            .finally(() => {
                setUpdating(false);
                dispatch(resetAdjustmentMidYearQualitative());
            });
    };

    const handleCloseModelObjective = () => {
        setIsOpenModalFormObjective(false);
    };

    useEffect(() => {
        dispatch(getAdjustmentMidYearQualitative({ krId: idKrBaseSelected, planPeriodId: filters?.planPeriodId }));
    }, [idKrBaseSelected]);

    return (
        <Spin delay={500} spinning={isUpdating || loadingAdjustmentMidYearQualitative}>
            <Form ref={modalContentRef} size="large" form={form} className="fw-bold" onFinish={handleSubmit} layout="vertical">
                <Row>
                    <Col className="fw-bold h3" md={24}>
                        {`ĐIỀU CHỈNH KẾ HOẠCH NĂM ${dayjs().year()}`}
                    </Col>
                </Row>
                <Row>
                    <Col md={11}>
                        <Form.Item label="Nội dung mục tiêu">
                            <TextArea rows={1} className="w-100" disabled value={adjustmentMidYearQualitative?.objective?.purpose} size="large" />
                        </Form.Item>
                    </Col>
                    <Col md={1} />
                    <Col md={3}>
                        <Form.Item label="Lĩnh vực">
                            <Input
                                className="w-100"
                                disabled
                                value={adjustmentMidYearQualitative?.objective?.fieldName}
                                size="large"
                            />
                        </Form.Item>
                    </Col>
                    <Col md={1} />
                    <Col md={3}>
                        <Form.Item label="Dự án">
                            <Input
                                className="w-100"
                                disabled
                                value={adjustmentMidYearQualitative?.objective?.projectName}
                                size="large"
                            />
                        </Form.Item>
                    </Col>
                    <Col md={1} />
                    <Col md={4}>
                        <Form.Item label="Mảng công việc">
                            <Input
                                className="w-100"
                                disabled
                                value={adjustmentMidYearQualitative?.objective?.workTypeName}
                                size="large"
                            />
                        </Form.Item>
                    </Col>
                </Row>
                <Row>
                    <Form.Item>
                        <span className="cursor-pointer text-primary" onClick={() => handleOpenModalAdjustmentObjective()}>
                            {`> Điều chỉnh mục tiêu`}
                        </span>
                    </Form.Item>
                </Row>
                <Row>
                    <Col md={13}>
                        <Row>
                            <Col md={2} />
                            <Col md={1} />
                            <Col className="fw-bold h3" md={18}>
                                KR đã duyệt
                            </Col>
                        </Row>
                        <Row className='d-flex align-items-center gap-2'>
                            <Col className="fw-bold h3" md={2}></Col>
                            <Col md={12}>Kết quả cần đạt được</Col>
                            <Col md={4}>Ngày bắt đầu</Col>
                            <Col md={5}>Thời hạn hoàn thành</Col>
                        </Row>
                        {adjustmentMidYearQualitative?.krApproved?.map((x, index) => {
                            return (
                                <Row key={`approve-${index}`} className="mt-2 d-flex align-items-center gap-2">
                                    <Col md={2}>
                                        <span className="fw-bold">{x.name}</span>
                                    </Col>
                                    <Col md={12}>
                                        <Form.Item>
                                            <TextArea rows={1} disabled title={x.purpose} className="w-100" value={x.oldPurpose} size="large" />
                                        </Form.Item>
                                    </Col>
                                    <Col md={4}>
                                        <Form.Item>
                                            <Input disabled className="w-100" value={dayjs(x.oldStartDate).format(APP_LOCAL_DATE_FORMAT)} size="large" />
                                        </Form.Item>
                                    </Col>
                                    <Col md={5}>
                                        <Form.Item>
                                            <Input disabled className="w-100" value={dayjs(x.oldDueDate).format(APP_LOCAL_DATE_FORMAT)} size="large" />
                                        </Form.Item>
                                    </Col>
                                </Row>
                            );
                        })}
                    </Col>
                    <Col md={11}>
                        <Row>
                            <Col className="fw-bold h3" md={18}>
                                KR điều chỉnh
                            </Col>
                        </Row>
                        <Row className="d-flex align-items-center gap-2">
                            <Col md={13}>Kết quả cần đạt được</Col>
                            <Col md={5}>Ngày bắt đầu</Col>
                            <Col md={5}>Thời hạn hoàn thành</Col>
                        </Row>
                        {adjustmentMidYearQualitative?.krApproved?.map((x, index) => {
                            return (
                                <Row className="mt-2 d-flex align-items-center gap-2" key={`adjust-${index}`}>
                                    <Col md={13}>
                                        <Form.Item
                                            rules={[
                                                {
                                                    required:
                                                        (index === 2 || index === 3 || index === 4)
                                                            ? purposeQuarterValue &&
                                                            !purposeMonthOneValue &&
                                                            !purposeMonthTwoValue &&
                                                            !purposeMonthThreeValue
                                                            : undefined,
                                                    message: 'Vui lòng nhập',
                                                },
                                            ]}
                                            initialValue={x.purpose}
                                            name={`purpose-${index}`}
                                        >
                                            <TextArea rows={1} title={x.purpose} className="w-100" size="large" />
                                        </Form.Item>
                                    </Col>
                                    <Col md={5}>
                                        <Form.Item initialValue={dayjs(x.startDate)} name={`startDate-${index}`}>
                                            <DatePicker allowClear={false} className="w-100" format={APP_LOCAL_DATE_FORMAT} size="large" />
                                        </Form.Item>
                                    </Col>
                                    <Col md={5}>
                                        <Form.Item initialValue={dayjs(x.dueDate)} name={`dueDate-${index}`}>
                                            <DatePicker allowClear={false} className="w-100" format={APP_LOCAL_DATE_FORMAT} size="large" />
                                        </Form.Item>
                                    </Col>
                                </Row>
                            );
                        })}
                    </Col>
                </Row>


                <Row>
                    <Col md={24}>
                        <Form.Item
                            label={<span className="fw-bold">Lý do điều chỉnh kế hoạch</span>}
                            name={'adjustmentReason'}
                        >
                            <TextArea rows={3} placeholder="Nhập lý do điều chỉnh kế hoạch" size="large" />
                        </Form.Item>
                    </Col>
                </Row>
                <Row>
                    <Col md={11}>
                        <Form.Item label={<span className="fw-bold">Khó khăn & nguyên nhân</span>} name={'adjustmentIssue'}>
                            <TextArea rows={6} placeholder="Nhập khó khăn & nguyên nhân" size="large" />
                        </Form.Item>
                    </Col>
                    <Col md={2} />
                    <Col md={11}>
                        <Form.Item label={<span className="fw-bold">Giải pháp và kiến nghị</span>} name={'adjustmentSolution'}>
                            <TextArea rows={6} placeholder="Nhập giải pháp và kiến nghị" size="large" />
                        </Form.Item>
                    </Col>
                </Row>

                <Row>
                    <Col md={24}>
                        <Form.Item label={<span className="fw-bold">Tài liệu đính kèm về kết quả thực hiện (link)</span>} name={'adjustmentNote'}>
                            <TextArea rows={3} placeholder="Nhập tài liệu đính kèm về kết quả thực hiện" size="large" />
                        </Form.Item>
                        <Form.Item valuePropName="checked" name={'sendingNotification'}>
                            <Checkbox>Gửi thông báo đến người nhận</Checkbox>
                        </Form.Item>
                    </Col>
                </Row>
                <Form.Item>
                    <Row className="d-flex gap-3 mt-3" justify="end">
                        <Col>
                            <Button
                                className="secondary"
                                onClick={() => {
                                    handleClose();
                                }}
                            >
                                Hủy
                            </Button>
                        </Col>
                        <Col>
                            <Button className="primary" htmlType="submit" disabled={isUpdating}>
                                Lưu
                            </Button>
                        </Col>
                    </Row>
                </Form.Item>
                {isOpenAdjustmentModel && (
                    <AdjustObjectiveUpdate isOpen={isOpenAdjustmentModel} onClose={handleCloseModalAdjustmentObjective} id={adjustmentMidYearQualitative?.objective?.id} />
                )}
                {isOpenModalFormObjective && (
                    <ObjectiveUpdate isOpen={isOpenModalFormObjective} id={adjustmentMidYearQualitative?.objective?.id} onClose={handleCloseModelObjective} />
                )}
            </Form>
        </Spin>
    );
};

export default CopyKRQualitativeVer;
